import React, { useState } from "react";
import styled, { css } from "react-emotion";
import LoginSignup from "../Authentication/LoginSignup";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import PricingView from "./PricingView";
import CurrentFeatures from "../NewLanding/CurrentFeatures";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const header = css`
  margin-bottom: 40px;
`;

const buttonContainerPricing = css`
  text-align: center;
  padding-bottom: 25px;
`;

const mdcButtonCard = css`
  width: 169px;
`;

const mdcButtonLabelFree = css`
  font-size: 12px;
  color: white;
`;

const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;

const offwhite = css`
  background-color: #f6fbfb;
`;

const footer = css`
  margin-bottom: 0px;
  position: absolute;
  bottom: 0;
  width: 100%;
`;

const mdcCard = css`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 590px;
  width: 100%;
  justify-content: space-between;
  border-radius: 10px;
  box-shadow: 0 5px 17px 1px rgba(136, 136, 136, 0.5);
  background-color: #ffffff;
  margin-bottom: 55px;
`;

const col1_3 = css`
  @media only screen and (min-width: 480px) {
    margin-bottom: 30px;
    margin-left: 2.5%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 30%;
  }
`;

const col1 = css`
  text-align: center;
`;

const pricingImg = css`
  padding: 20px 0px;
  width: 175px;
`;

const pricingImg2 = css`
  padding: 20px 0px;
  width: 300px;
  @media only screen and (min-width: 480px) {
    width: 500px;
  }
  @media only screen and (min-width: 768px) {
    width: 800px;
  }
`;

const center = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const cardText = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  white-space: pre-wrap;
`;

const ulCard = css`
  list-style-type: circle;
  color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 20px;
  padding: auto;
  list-style-position: inside;
`;

const firstCardList = css`
  padding-top: 23px;
  @media only screen and (min-width: 1012px) {
    padding-top: 64px;
  }
`;

const thirdCardList = css`
  padding-top: 15px;
  @media only screen and (min-width: 981px) {
    padding-top: 50px;
  }
`;
const sliderLabel = css`
  margin-bottom: 0px;
  padding-top: 15px;
  justify-content: space-between;
`;

const small = css`
  margin: 0px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 11px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #818181;
`;

const smallBlack = css`
  margin: 0px;
  margin-top: 10px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
`;

const slideContainer = css`
  text-align: center;
  width: 100%;
`;

const slider = css`
  -webkit-appearance: none;
  width: 85%;
  height: 8px;
  border-radius: 5px;
  background: rgba(137, 210, 211, 0.3);
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #89d2d3;
    /* background: white; */
    cursor: pointer;
  }
  ::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #4caf50;
    cursor: pointer;
  }
`;
const liCard = css`
  padding-bottom: 5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  margin: auto;
  padding: auto;
  text-align: left;
`;

const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
`;

const H3 = styled("h3")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 30px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin: 29px 29px 5px 29px;
`;

const H4 = styled("h4")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin: 29px 29px 5px 29px;
`;

const H5 = styled("h5")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #89d2d3;
  margin: 10px 0px;
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

function Pricing({ history }) {
  const [sliderProgress, setSliderProgress] = useState(20);
  function inRange(x, min, max) {
    return (x - min) * (x - max) <= 0;
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  });
  // const appDownloads = Math.round(sliderProgress / 10) * 10;
  const appDownloads = () => {
    if (sliderProgress != 1000) {
      // return formatter.format(Math.round(sliderProgress / 10) * 10);
      return formatter.format(Math.round(sliderProgress));
    } else {
      return "1,000";
    }
  };
  const revenue = () => {
    if (appDownloads() != 1000 && appDownloads() != "1,000") {
      return "$" + formatter.format(appDownloads() * 10);
    } else {
      return "$" + formatter.format(1000 * 10);
    }
  };
  const newPrice = () => {
    if (inRange(appDownloads(), 0, 20)) {
      return "$19.99/mo";
    } else if (inRange(appDownloads(), 21, 50)) {
      return "$29.99/mo";
    } else if (inRange(appDownloads(), 51, 100)) {
      return "$49.99/mo";
    } else if (inRange(appDownloads(), 101, 200)) {
      return "$99.99/mo";
    } else if (inRange(appDownloads(), 201, 300)) {
      return "$149.99/mo";
    } else if (inRange(appDownloads(), 301, 400)) {
      return "$199.99/mo";
    } else if (inRange(appDownloads(), 401, 499)) {
      return "$249.99/mo";
    } else if (inRange(appDownloads(), 500, 500)) {
      return "$249.99/mo + $0.50 / additional download";
    } else {
      return "$99.99/mo";
    }
  };

  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <div className={styles.row}>
          <div className={styles.maxWidthWrapper}>
            <div className={col + " " + col1} style={{ textAlign: "right" }}>
              <styles.H2
                style={{
                  textAlign: "center",
                  margin: "30px 0px",
                  width: "100%",
                }}
              >
                <span className={styles.styledUnderline}>
                  Plans and Pricing
                </span>
                <br></br>{" "}
              </styles.H2>
              <PricingView />
              <div style={{ textAlign: "center", marginTop: "3.5rem" }}>
                <LoginSignup
                  buttonText="Get Started for Free"
                  // width="400px"
                  fontWeight="bold"
                  fontSize="20px"
                />
              </div>
              <P style={{ textAlign: "center" }}>
                100% free to get started. No credit card required.
              </P>
            </div>
          </div>
        </div>
        <CurrentFeatures noTitle={true} />
        <Footer />
      </div>
    </div>
  );
}

export default Pricing;
